module.exports = __webpack_public_path__ + "img/service3.23676391.png";